/**
 * 現地調査依頼画面のダミーデータ（レイアウト・遷移確認用のモック）
 *
 * GraphQLのoperation名ごとにダミーのレスポンスを返す。登録・更新などの操作は状態を持たない。
 */
// --- コードマスタ ---
const CODE_MASTER = {
    status_site_survey: [
        ['001', '部門承認待ち(M)'], ['002', '部門承認済(M)'], ['003', '部門差戻'], ['004', '部門中止'],
        ['005', '自動却下'], ['010', '建築差戻'], ['110', '建築確認中'], ['120', '建築確認済(担当)'],
        ['130', '現調書作成済(設計事務所)'], ['210', '建築承認済(担当)'], ['220', '建築承認済(M)'],
        ['230', '建築承認済(GM)'], ['310', '建築承認済(本部長)'], ['410', '建築中止'],
    ],
    handling_type: [
        ['010', '新店'], ['011', '新店(S&B)'], ['012', '新店(セットバック)'], ['020', '閉店新店(R)'],
        ['030', '駐車場拡大'], ['031', '乗入拡幅'], ['032', '駐車場拡大＋乗入拡幅'],
    ],
    prefecture: [
        ['11', '埼玉県'], ['12', '千葉県'], ['13', '東京都'], ['14', '神奈川県'], ['23', '愛知県'], ['27', '大阪府'], ['40', '福岡県'],
    ],
    contract_type: [['A', 'A'], ['B', 'B'], ['C', 'C']],
    ownership_type: [['1', '自己所有'], ['2', '賃借'], ['3', 'オーナー所有']],
    building_type: [['1', '単独店舗'], ['2', 'テナント'], ['3', 'ビルイン']],
    license_plan: [['1', 'あり'], ['2', 'なし']],
    submission_method: [['1', '一式納品'], ['2', '随時納品']],
};
function nameOf(type, code) {
    return (CODE_MASTER[type] || []).find(([c]) => c === code)?.[1] ?? '';
}
// ステータス14種を1件ずつ（1ページ10件を超えて2ページ目も確認できる）
const REQUESTS = [
    { statusCode: '001', handlingTypeCode: '010', candidateId: 'A0000101', storeNo: '', storeName: 'システムテスト店 新店A', prefectureCode: '13', contractTypeCode: 'A', requestCount: 1, submissionMethodCode: '1', designOffice: '', hasBox: false },
    { statusCode: '002', handlingTypeCode: '011', candidateId: 'A0000102', storeNo: '', storeName: 'システムテスト店 新店B', prefectureCode: '14', contractTypeCode: 'B', requestCount: 1, submissionMethodCode: '1', designOffice: '', hasBox: false },
    { statusCode: '003', handlingTypeCode: '030', candidateId: '', storeNo: '000023', storeName: 'システムテスト店 駐車場', prefectureCode: '14', contractTypeCode: 'C', requestCount: 1, submissionMethodCode: '2', designOffice: '', hasBox: true },
    { statusCode: '004', handlingTypeCode: '031', candidateId: '', storeNo: '000024', storeName: 'システムテスト店 乗入', prefectureCode: '12', contractTypeCode: 'A', requestCount: 1, submissionMethodCode: '1', designOffice: '', hasBox: true },
    { statusCode: '005', handlingTypeCode: '032', candidateId: '', storeNo: '000025', storeName: 'システムテスト店 駐車場乗入', prefectureCode: '11', contractTypeCode: 'B', requestCount: 2, submissionMethodCode: '2', designOffice: '', hasBox: true },
    { statusCode: '010', handlingTypeCode: '010', candidateId: 'A0000103', storeNo: '', storeName: 'システムテスト店 新店C', prefectureCode: '23', contractTypeCode: 'C', requestCount: 1, submissionMethodCode: '1', designOffice: 'サンプル設計事務所', hasBox: true },
    { statusCode: '110', handlingTypeCode: '012', candidateId: 'A0000104', storeNo: '', storeName: 'システムテスト店 新店D', prefectureCode: '27', contractTypeCode: 'A', requestCount: 1, submissionMethodCode: '1', designOffice: 'サンプル設計事務所', hasBox: true },
    { statusCode: '120', handlingTypeCode: '020', candidateId: 'A0000105', storeNo: '000031', storeName: 'システムテスト店 閉店新店', prefectureCode: '40', contractTypeCode: 'B', requestCount: 1, submissionMethodCode: '2', designOffice: 'サンプル設計事務所', hasBox: true },
    { statusCode: '130', handlingTypeCode: '010', candidateId: 'A0000106', storeNo: '', storeName: 'システムテスト店 新店E', prefectureCode: '13', contractTypeCode: 'C', requestCount: 1, submissionMethodCode: '1', designOffice: 'テスト建築設計', hasBox: true },
    { statusCode: '210', handlingTypeCode: '030', candidateId: '', storeNo: '000026', storeName: 'システムテスト店 駐車場2', prefectureCode: '14', contractTypeCode: 'A', requestCount: 1, submissionMethodCode: '2', designOffice: 'テスト建築設計', hasBox: true },
    { statusCode: '220', handlingTypeCode: '031', candidateId: '', storeNo: '000027', storeName: 'システムテスト店 乗入2', prefectureCode: '12', contractTypeCode: 'B', requestCount: 1, submissionMethodCode: '1', designOffice: 'テスト建築設計', hasBox: true },
    { statusCode: '230', handlingTypeCode: '011', candidateId: 'A0000107', storeNo: '', storeName: 'システムテスト店 新店F', prefectureCode: '11', contractTypeCode: 'C', requestCount: 1, submissionMethodCode: '1', designOffice: 'テスト建築設計', hasBox: true },
    { statusCode: '310', handlingTypeCode: '010', candidateId: 'A0000108', storeNo: '', storeName: 'システムテスト店 新店G', prefectureCode: '23', contractTypeCode: 'A', requestCount: 3, submissionMethodCode: '1', designOffice: 'サンプル設計事務所', hasBox: true },
    { statusCode: '410', handlingTypeCode: '012', candidateId: 'A0000109', storeNo: '', storeName: 'システムテスト店 新店H', prefectureCode: '27', contractTypeCode: 'B', requestCount: 2, submissionMethodCode: '2', designOffice: '', hasBox: true },
];
const ZO_DO = {
    '11': { zo: '001', zoName: '北関東ZO', do: '00011', doName: '埼玉DO' },
    '12': { zo: '002', zoName: '千葉ZO', do: '00012', doName: '千葉DO' },
    '13': { zo: '003', zoName: '東京ZO', do: '00013', doName: '東京DO' },
    '14': { zo: '004', zoName: '神奈川ZO', do: '00014', doName: '横浜DO' },
    '23': { zo: '005', zoName: '東海ZO', do: '00023', doName: '名古屋DO' },
    '27': { zo: '006', zoName: '関西ZO', do: '00027', doName: '大阪DO' },
    '40': { zo: '007', zoName: '九州ZO', do: '00040', doName: '福岡DO' },
};
const BOX_URL = 'https://example.box.com/folder/';
function internalIdOf(index) {
    return 'IDS' + String(index + 1).padStart(9, '0');
}
function buildListItem(r, index) {
    const id = internalIdOf(index);
    return {
        requestId: id,
        statusCode: r.statusCode,
        statusName: nameOf('status_site_survey', r.statusCode),
        internalId: id,
        handlingTypeCode: r.handlingTypeCode,
        handlingTypeName: nameOf('handling_type', r.handlingTypeCode),
        candidateId: r.candidateId,
        prefectureCode: r.prefectureCode,
        prefectureName: nameOf('prefecture', r.prefectureCode),
        storeNo: r.storeNo,
        storeName: r.storeName,
        contractTypeCode: r.contractTypeCode,
        contractTypeName: nameOf('contract_type', r.contractTypeCode),
        requestCount: r.requestCount,
        submissionMethodCode: r.submissionMethodCode,
        submissionMethodName: nameOf('submission_method', r.submissionMethodCode),
        designOffice: r.designOffice,
        boxLink: r.hasBox ? `${BOX_URL}request-${id}` : '',
        approvalBoxLink: r.hasBox && Number(r.statusCode) >= 110 ? `${BOX_URL}approval-${id}` : '',
        reportBoxLink: r.hasBox && Number(r.statusCode) >= 130 ? `${BOX_URL}report-${id}` : '',
    };
}
function buildDocuments(index) {
    const required = ['公図', '住宅地図', '敷地実測図', '簡易CAD', '簡易概算'];
    const optional = ['土地謄本', '建物謄本'];
    return [...required, ...optional].map((name, i) => ({
        documentType: i < required.length ? 'required' : 'optional',
        documentName: name,
        fileName: `20261015_${String(i + 1).padStart(2, '0')}_${name}.pdf`,
        uploader: '山田 太郎',
        uploadDate: '2026/10/15 10:00:00',
        gcsPath: `${internalIdOf(index)}/20261015_${String(i + 1).padStart(2, '0')}_${name}.pdf`,
    }));
}
function buildDetail(r, index) {
    const item = buildListItem(r, index);
    const zd = ZO_DO[r.prefectureCode];
    const isRejectedOrCanceled = ['003', '004', '005', '010', '410'].includes(r.statusCode);
    return {
        ...item,
        requestDate: '2026/10/15',
        storeNameKana: 'システムテストテン',
        zo: zd.zo,
        zoName: zd.zoName,
        do: zd.do,
        doName: zd.doName,
        address: '東京都千代田区サンプル1-2-3',
        ownershipCode: '1',
        ownershipName: nameOf('ownership_type', '1'),
        buildingTypeCode: '1',
        buildingTypeName: nameOf('building_type', '1'),
        licenseCode: '1',
        licenseName: nameOf('license_plan', '1'),
        openDate: '2027/04/01',
        surveyDesiredDate: '2026/11/01',
        reportDueDate: '2026/11/30',
        confirmation: true,
        retryReason: r.requestCount > 1 ? '条件変更のため再依頼します。' : '',
        remarks: isRejectedOrCanceled ? '差戻・中止の理由が入ります。' : 'ダミーの備考です。',
        requesterCode: 'a000010',
        requesterName: '小林 七海',
        approverCode: 'a000001',
        approverName: '山田 太郎',
        dmCode: 'a000020',
        dmName: '伊藤 四郎',
        designOfficeCode: r.designOffice ? 'V000001' : '',
        designOfficeName: r.designOffice,
        approvalDept: Number(r.statusCode) >= 2 && r.statusCode !== '003' && r.statusCode !== '004' ? '2026/10/16 山田 太郎' : '',
        approvalArch: Number(r.statusCode) >= 210 && r.statusCode !== '410' ? '2026/10/25 建築 担当' : '',
        documents: buildDocuments(index),
    };
}
function findIndex(id) {
    const idx = REQUESTS.findIndex((_, i) => internalIdOf(i) === id);
    return idx >= 0 ? idx : 0;
}
// --- 検索用マスタ ---
const CANDIDATES = [
    { candidateId: 'A0000101', storeName: 'システムテスト店 新店A', storeNameKana: 'システムテストテン シンテンエー', prefectureCode: '13', contractTypeCode: 'A', ownershipCode: '1', address: '東京都千代田区サンプル1-2-3' },
    { candidateId: 'A0000102', storeName: 'システムテスト店 新店B', storeNameKana: 'システムテストテン シンテンビー', prefectureCode: '14', contractTypeCode: 'B', ownershipCode: '2', address: '神奈川県横浜市サンプル4-5-6' },
    { candidateId: 'A0000103', storeName: 'システムテスト店 新店C', storeNameKana: 'システムテストテン シンテンシー', prefectureCode: '23', contractTypeCode: 'C', ownershipCode: '3', address: '愛知県名古屋市サンプル7-8-9' },
];
const STORES = [
    { storeNo: '000023', storeName: 'システムテスト店 駐車場', storeNameKana: 'システムテストテン チュウシャジョウ', prefectureCode: '14', contractTypeCode: 'C', ownershipCode: '1', address: '神奈川県川崎市サンプル1-1-1', dmCode: 'a000020', dmName: '伊藤 四郎' },
    { storeNo: '000024', storeName: 'システムテスト店 乗入', storeNameKana: 'システムテストテン ノリイレ', prefectureCode: '12', contractTypeCode: 'A', ownershipCode: '2', address: '千葉県千葉市サンプル2-2-2', dmCode: 'a000021', dmName: '渡辺 五郎' },
    { storeNo: '000031', storeName: 'システムテスト店 閉店新店', storeNameKana: 'システムテストテン ヘイテンシンテン', prefectureCode: '40', contractTypeCode: 'B', ownershipCode: '3', address: '福岡県福岡市サンプル3-3-3', dmCode: 'a000022', dmName: '中村 六子' },
];
function withNames(s) {
    const zd = ZO_DO[s.prefectureCode];
    return {
        ...s,
        prefectureName: nameOf('prefecture', s.prefectureCode),
        contractTypeName: nameOf('contract_type', s.contractTypeCode),
        ownershipName: nameOf('ownership_type', s.ownershipCode),
        zo: zd.zo,
        do: zd.do,
    };
}
const EMPLOYEES = [
    { employeeCode: 'a000001', employeeName: '山田 太郎', departmentName: 'リクルート部', position: 'M' },
    { employeeCode: 'a000002', employeeName: '佐藤 花子', departmentName: '法人営業部', position: 'M' },
    { employeeCode: 'a000003', employeeName: '鈴木 一郎', departmentName: '店舗事業開発部', position: 'M' },
    { employeeCode: 'a000004', employeeName: '田中 次郎', departmentName: 'リクルート部', position: 'GM' },
    { employeeCode: 'a000005', employeeName: '高橋 三郎', departmentName: '法人営業部', position: 'GM' },
    { employeeCode: 'a000010', employeeName: '小林 七海', departmentName: 'リクルート部', position: '' },
    { employeeCode: 'a000011', employeeName: '加藤 八重', departmentName: '店舗事業開発部', position: '' },
    { employeeCode: 'a000020', employeeName: '伊藤 四郎', departmentName: 'オペレーション本部 第1ブロック', position: 'DM' },
    { employeeCode: 'a000021', employeeName: '渡辺 五郎', departmentName: 'オペレーション本部 第2ブロック', position: 'DM' },
    { employeeCode: 'a000022', employeeName: '中村 六子', departmentName: 'オペレーション本部 第3ブロック', position: 'DM' },
];
const PARTNERS = [
    { partnerCode: 'V000001', partnerName: 'サンプル設計事務所', partnerType: '設計事務所' },
    { partnerCode: 'V000002', partnerName: 'テスト建築設計', partnerType: '設計事務所' },
    { partnerCode: 'V000003', partnerName: 'ダミーコンサルタント', partnerType: 'コンサルタント' },
];
const includes = (value, keyword) => !keyword || value.includes(String(keyword));
// --- operation名ごとのレスポンス ---
const HANDLERS = {
    codeMasters: (v) => {
        const types = v?.codeTypes ?? Object.keys(CODE_MASTER);
        return {
            codeMasters: types.filter(t => CODE_MASTER[t]).map(t => ({
                itemName: t,
                items: CODE_MASTER[t].map(([codeValue, codeDisplay], i) => ({ codeValue, codeDisplay, sortOrder: i + 1 })),
            })),
        };
    },
    getOperationPermissions: () => ({
        operationPermissions: [{
                pageId: 'SITE_SURVEY', permissionType: '0006',
                ssNewRequest: true, ssRevision: true, ssApprove: true, ssHistory: true, ssReRequest: true,
                rsNewRequest: false, rsRevision: false, rsApprove: false, rsHistory: false, rsReRequest: false,
                handlingCategory: null,
            }],
    }),
    fieldSurveyRequests: (v) => {
        const page = Number(v?.page ?? 1);
        const perPage = Number(v?.perPage ?? 10);
        const items = REQUESTS.map((r, i) => buildListItem(r, i)).filter(it => (!v?.status || it.statusCode === v.status) &&
            includes(it.internalId, v?.internalId) &&
            (!v?.handlingType || it.handlingTypeCode === v.handlingType) &&
            includes(it.candidateId, v?.candidateId) &&
            includes(it.storeNo, v?.storeNo) &&
            includes(it.storeName, v?.storeName) &&
            (!v?.prefecture || it.prefectureCode === v.prefecture) &&
            (!v?.contractType || it.contractTypeCode === v.contractType) &&
            (v?.requestCount == null || it.requestCount === v.requestCount) &&
            (!v?.submissionMethod || it.submissionMethodCode === v.submissionMethod) &&
            includes(it.designOffice, v?.designOffice));
        return {
            fieldSurveyRequests: {
                totalCount: items.length, page, perPage,
                items: items.slice((page - 1) * perPage, page * perPage),
            },
        };
    },
    fieldSurveyRequestDetail: (v) => {
        const i = findIndex(v?.internalId);
        return { fieldSurveyRequestDetail: buildDetail(REQUESTS[i], i) };
    },
    fieldSurveyRequestStatus: (v) => {
        const i = findIndex(v?.internalId);
        return {
            fieldSurveyRequestStatus: {
                statusCode: REQUESTS[i].statusCode,
                statusName: nameOf('status_site_survey', REQUESTS[i].statusCode),
            },
        };
    },
    generateFieldSurveyInternalId: () => ({ generateFieldSurveyInternalId: { internalId: 'IDS000000099' } }),
    initNewRequest: () => ({
        generateFieldSurveyInternalId: { internalId: 'IDS000000099' },
        myDepartmentManager: { employeeCode: 'a000001', employeeName: '山田 太郎' },
    }),
    storeInfo: (v) => {
        const s = STORES.find(x => x.storeNo === v?.storeNo) ?? STORES[0];
        return { storeInfo: withNames(s) };
    },
    candidateSearch: (v) => {
        const input = (v?.input ?? {});
        const items = CANDIDATES
            .filter(c => includes(c.candidateId, input.candidateId) && includes(c.storeName, input.storeName))
            .map(withNames);
        return { candidateSearch: { totalCount: items.length, items } };
    },
    storeSearch: (v) => {
        const input = (v?.input ?? {});
        const items = STORES
            .filter(s => includes(s.storeNo, input.storeNo) && includes(s.storeName, input.storeName))
            .map(withNames);
        return { storeSearch: { totalCount: items.length, items } };
    },
    employeeSearch: (v) => {
        const input = (v?.input ?? {});
        const fixed = input.searchType === 'APPROVER' ? ['M', 'GM'] : input.searchType === 'DM' ? ['DM'] : [];
        const items = EMPLOYEES
            .filter(e => includes(e.departmentName, input.departmentName) &&
            includes(e.employeeName, input.employeeName) &&
            (!input.position || e.position === input.position) &&
            (fixed.length === 0 || fixed.includes(e.position)))
            .map(e => ({ ...e, hasApprovalAuthority: e.position === 'M' || e.position === 'GM', hasDmAuthority: e.position === 'DM' }));
        return { employeeSearch: { totalCount: items.length, items } };
    },
    partnerSearch: (v) => {
        const input = (v?.input ?? {});
        const items = PARTNERS.filter(p => includes(p.partnerName, input.partnerName) && (!input.partnerType || p.partnerType === input.partnerType));
        return { partnerSearch: { totalCount: items.length, items } };
    },
};
/** ダミーデータを返せるoperationならレスポンスを返す。対象外ならundefined（通常のAPI呼び出しに回す） */
export function resolveFieldSurveyMock(query, variables) {
    const name = /query\s+(\w+)/.exec(query)?.[1];
    const handler = name ? HANDLERS[name] : undefined;
    return handler ? handler(variables) : undefined;
}
// --- ZO/DO（zodoData用） ---
export const MOCK_ZONES = Object.values(ZO_DO).map(z => ({ zone_code: z.zo, zone_name: z.zoName }));
export const MOCK_DOS = Object.values(ZO_DO).map(z => ({ do_code: z.do, do_name: z.doName }));
/** モック: 画面の表示（プログレスバーなど）を見せるための待ち時間 */
export const mockWait = (ms = 700) => new Promise(resolve => setTimeout(resolve, ms));
